"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUpdateOfferItemFailedResponse = exports.UpdateOfferItemFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'update-offer-item-failed';
const UpdateOfferItemFailedEvent = exports.UpdateOfferItemFailedEvent = Name;
const isUpdateOfferItemFailedResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isUpdateOfferItemFailedResponse = isUpdateOfferItemFailedResponse;
//# sourceMappingURL=index.js.map